import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";
import CommonModal from "./CommonModal";
import Button from "../Elements/Button";

const ReplaceConfirmModal = ({ show, info, onConfirm, onCancel }) => {
  const bits = [];
  if (info?.has_laserlink) bits.push("a LaserLink");
  if (info?.has_navigator) bits.push("a Navigator");
  const what = bits.join(" and ") || "page-anchored content";

  return (
    <CommonModal
      title={"Replace this PDF?"}
      modalStatus={show}
      changeActiveStatus={onCancel}
      classList="header-profile-modal-wrapper alert-modal"
      showFooter={false}
      centered
    >
      <div className="clone-modal page-limit-modal">
        <div className="page-limit-summary">
          <FontAwesomeIcon icon={faTriangleExclamation} />
          <span>
            This edition has <strong>{what}</strong>.
          </span>
        </div>
        <ul className="page-limit-reasons">
          <li>We&apos;ll check where each page&apos;s content moved in the new PDF and replace your elements to match.</li>
          <li>We adapt the navigator for your review and approval.</li>
          <li>You can revert to the previous PDF afterwards from the editor.</li>
        </ul>
        <div className="page-limit-question">Do you want to replace it?</div>
        <div className="kdf-btn mt-3">
          <Button
            text={"Cancel"}
            classList={"alert"}
            addonClass={"me-1 px-2"}
            onClick={onCancel}
          />
          <Button
            text={"Replace"}
            classList={"success"}
            type="submit"
            addonClass={"px-2 common-modal-yes-button"}
            onClick={onConfirm}
          />
        </div>
      </div>
    </CommonModal>
  );
};

export default ReplaceConfirmModal;
